import {
  compose,
  createStore,
  applyMiddleware,
  Store,
  combineReducers,
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { bookingReducer } from '@mapado/cart';
import { seatingReducer } from '@mapado/seating';

// vite version
const isDev = import.meta.env.DEV;

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: Function;
  }
}

type RootState = {
  booking: ReturnType<typeof bookingReducer>;
  seating: ReturnType<typeof seatingReducer>;
};

const rootReducer = combineReducers<RootState>({
  booking: bookingReducer, // needed in RootState type
  seating: seatingReducer,
});

/* eslint-disable no-underscore-dangle */
export default function configureStore(): Store<RootState> {
  const composeEnhancer =
    isDev && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ trace: false })
      : compose;

  const middleWares = [thunkMiddleware];
  const middlewareEnhancer = applyMiddleware(...middleWares);
  const composedEnhancers = composeEnhancer(middlewareEnhancer);

  const store = createStore(rootReducer, undefined, composedEnhancers);

  return store;
}
/* eslint-enable no-underscore-dangle */
